import React from 'react';

// reactstrap components
import {
	Button,
	Card,
	CardHeader,
	CardBody,
	FormGroup,
	Form,
	Input,
	InputGroupAddon,
	InputGroupText,
	InputGroup,
	Container,
	Row,
	Col,
} from 'reactstrap';

//import FacebookLogin from 'react-facebook-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { GoogleLogin, GoogleLogout } from 'react-google-login';
import { Link } from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FACEBOOK_ID, GOOGLE_ID } from '../../config/config';
import Api from '../../config/Api';
import Jwt from '../../config/JWT';
// core components
//import DemoNavbar from 'components/Navbars/DemoNavbar.js';
import SimpleFooter from 'components/Footers/SimpleFooter.js';
import Notif from '../../components/Notification/Notif';
import Loadings from '../../components/Loading/LoadingSpiner';
//var md5 = require('md5');
class Login extends React.Component {
	state = {
		masuk: false,
	};
	componentDidMount() {
		document.documentElement.scrollTop = 0;
		document.scrollingElement.scrollTop = 0;
	}

	responseFacebook = async (res) => {
		if (res) {
			this.setState(
				{
					email: res.email ? res.email : res.id,
					tipeLogin: 'facebook',
					nama: res.name,
					foto: res.picture ? res.picture.data.url : res.picture,
				},

				async () => {
					await Api.post('penduduk/check_login', this.state).then((login) => {
						this.setState({
							loading: false,
						});
						if (!login.data.status) {
							Notif('e', '😇', login.data.data.nama, 'Anda Gagal Masuk. Sepertinya anda telah dibanned');
						} else {
							sessionStorage.setItem('namaP', login.data.data.nama);
							sessionStorage.setItem('margaP', login.data.data.marga);
							sessionStorage.setItem('emailP', login.data.data.email);
							sessionStorage.setItem('nonik', login.data.data.nonik);
							sessionStorage.setItem('idP', login.data.data.id);
							sessionStorage.setItem('fotoP', res.picture ? res.picture.data.url : res.picture);
							sessionStorage.setItem('fotoProfilP', login.data.data.foto);
							sessionStorage.setItem('mkomentar', login.data.data.mkomentar);
							sessionStorage.setItem('mberita', login.data.data.mberita);
							sessionStorage.setItem('mpenduduk', login.data.data.mpenduduk);
							sessionStorage.setItem('mpajak', login.data.data.mpajak);
							sessionStorage.setItem('mdanadesa', login.data.data.mdanadesa);
							sessionStorage.setItem('mlogin', login.data.data.mlogin);
							sessionStorage.setItem('makses', login.data.data.makses);
							Notif('s', '✔️', sessionStorage.getItem('namaP'), 'Anda Berhasil Masuk');
							setTimeout(() => {
								this.setState({
									login: true,
								});
							}, 2000);
						}
					});
				}
			);
		} else {
			this.setState({
				login: false,
			});
		}
	};
	responseGoogle = async (res) => {
		if (!res.error) {
			this.setState({
				id_token: res.tokenId,
			});
			localStorage.setItem('tokenId', res.tokenId);

			await Jwt.post('oauth2/v3/tokeninfo?', this.state).then((g) => {
				this.setState(
					{
						email: g.data.email,
					},
					async () => {
						await Api.post('admin_api/login', this.state).then((login) => {
							console.log(login.data.status);
							if (login.data.status === true) {
								this.setState({
									masuk: true,
								});
								localStorage.setItem('namaAdmin', g.data.given_name + ' ' + g.data.family_name);
								sessionStorage.setItem('namaAdmin', g.data.given_name + ' ' + g.data.family_name);
								Notif('d', '✔️', g.data.given_name, 'Anda Berhasil Login ');
							} else {
								Notif(
									'e',
									'😇',
									g.data.given_name,
									'Anda tidak memiliki hak untuk mengolah data. Silahkan hubungi Fadly '
								);
								this.setState(
									{
										masuk: false,
									},
									() => {
										sessionStorage.clear();
										localStorage.clear();
									}
								);
							}
						});
					}
				);
			});
		}
	};
	keluar = () => {
		sessionStorage.clear();
		localStorage.clear();
		this.setState({
			masuk: false,
		});
	};
	render() {
		let TombolGoogle = (
			<GoogleLogin
				clientId={GOOGLE_ID}
				render={(e) => (
					<Button
						className="btn-neutral btn-icon ml-1"
						color="default"
						onClick={e.onClick}
						disabled={e.disabled}
					>
						<span className="btn-inner--icon mr-1">
							<img alt="..." src={require('assets/img/icons/common/google.svg')} />
						</span>
						<small className="btn-inner--text">Google</small>
					</Button>
				)}
				buttonText="Login"
				onSuccess={this.responseGoogle}
				onFailure={this.responseGoogle}
				cookiePolicy={'single_host_origin'}
				isSignedIn
			/>
		);
		let tombolAdmin = (
			<CardBody className="px-lg-5 py-lg-5">
				<div className="text-center text-muted mb-4">
					<small>Atau Masuk dengan Password</small>
				</div>
				<Form role="form">
					<FormGroup className="mb-3">
						<InputGroup className="input-group-alternative">
							<InputGroupAddon addonType="prepend">
								<InputGroupText>
									<i className="ni ni-email-83" />
								</InputGroupText>
							</InputGroupAddon>
							<Input placeholder="Email" type="email" />
						</InputGroup>
					</FormGroup>
					<FormGroup>
						<InputGroup className="input-group-alternative">
							<InputGroupAddon addonType="prepend">
								<InputGroupText>
									<i className="ni ni-lock-circle-open" />
								</InputGroupText>
							</InputGroupAddon>
							<Input placeholder="Password" type="password" autoComplete="off" />
						</InputGroup>
					</FormGroup>
					<div className="custom-control custom-control-alternative custom-checkbox">
						<input className="custom-control-input" id=" customCheckLogin" type="checkbox" />
						<label className="custom-control-label" htmlFor=" customCheckLogin">
							<span>Remember me</span>
						</label>
					</div>
					<div className="text-center">
						<Button className="my-4" color="primary" type="button">
							Masuk
						</Button>
					</div>
				</Form>
			</CardBody>
		);
		if (this.state.masuk === true) {
			TombolGoogle = (
				<GoogleLogout
					clientId={GOOGLE_ID}
					render={(e) => (
						<Button
							className="btn-neutral btn-icon ml-1"
							color="default"
							onClick={e.onClick}
							disabled={e.disabled}
						>
							<span className="btn-inner--icon mr-1">
								<img alt="..." src={require('assets/img/icons/common/google.svg')} />
							</span>
							<small className="btn-inner--text">Keluar</small>
						</Button>
					)}
					buttonText="Logout"
					onLogoutSuccess={this.keluar}
				></GoogleLogout>
			);
			tombolAdmin = (
				<Link to="/admin/tambah-data">
					<Button color="primary" size="lg" type="button" block>
						Masuk Menu Admin
					</Button>
				</Link>
			);
		}

		return (
			<>
				<Loadings loading={this.state.loading} />
				{/* <DemoNavbar /> */}
				<main ref="main">
					<section className="section section-shaped section-lg">
						<div className="shape shape-style-1 bg-gradient-default">
							<span />
							<span />
							<span />
							<span />
							<span />
							<span />
							<span />
							<span />
						</div>
						<Container className="pt-lg-7">
							<Row className="justify-content-center">
								<Col lg="5">
									<Card className="bg-secondary shadow border-0">
										<CardHeader className="bg-white pb-5">
											<div className="text-muted text-center mb-3">
												<small>Masuk dengan:</small>
											</div>
											<div className="btn-wrapper text-center">
												<FacebookLogin
													appId={FACEBOOK_ID}
													autoLoad={false}
													isMobile={false}
													fields={'name,email,picture'}
													callback={this.responseFacebook}
													disabled
													render={(e) => (
														<Button
															className="btn-neutral btn-icon"
															color="default"
															onClick={e.onClick}
														>
															<span className="btn-inner--icon mr-1">
																<img
																	alt="..."
																	src={require('assets/img/icons/common/facebook.svg')}
																/>
															</span>
															<small className="btn-inner--text">Facebook</small>
														</Button>
													)}
												/>
												{TombolGoogle}
											</div>
										</CardHeader>
										{tombolAdmin}
									</Card>
									<Row className="mt-3">
										<Link to="/">
											<Col xs="12 text-center">
												<small>Ke Dashboard.</small>
											</Col>
										</Link>
									</Row>
								</Col>
							</Row>
						</Container>
					</section>
				</main>
				<ToastContainer />
				<SimpleFooter />
			</>
		);
	}
}

export default Login;
